module.exports = __webpack_public_path__ + "static/media/plate-design.dc17dc94.png";